import { useMemo } from 'react';

import {
  useIsCommunityDraftPostEnabled,
  useIsPostOnBehalfOfDraftEnabled,
  useIsQuestionsOnlyMode,
  useIsScheduledPostEnabled,
  useIsStorylineDraftPostEnabled,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useDraftPostSettings: UseMainUIFeatureSettings<'draftPost'> = (options) => {
  const draftPostOverrides = options?.overrides?.draftPost;
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  const isStorylineDraftPostEnabled = useIsStorylineDraftPostEnabled();
  const isCommunityDraftPostEnabled = useIsCommunityDraftPostEnabled();
  const isPostOnBehalfOfDraftEnabled = useIsPostOnBehalfOfDraftEnabled();
  const isScheduledPostEnabled = useIsScheduledPostEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        isStorylineDraftPostEnabled: false,
        isCommunityDraftPostEnabled: false,
        isPostOnBehalfOfDraftEnabled: false,
        isScheduledPostEnabled: false,
        ...draftPostOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isStorylineDraftPostEnabled || isCommunityDraftPostEnabled,
      isStorylineDraftPostEnabled,
      isCommunityDraftPostEnabled,
      isPostOnBehalfOfDraftEnabled,
      isScheduledPostEnabled,
      ...draftPostOverrides,
    };
  }, [
    isQuestionsOnlyMode,
    isStorylineDraftPostEnabled,
    isCommunityDraftPostEnabled,
    isPostOnBehalfOfDraftEnabled,
    isScheduledPostEnabled,
    draftPostOverrides,
  ]);
};
